import axios, { HttpStatusCode } from "axios";
import type { TechnicalSheet } from "@/pages/management/technicalsheets/technicalsheet/services/dto/TechnicalSheet.ts";

export async function getTechnicalSheetData(
  technicalSheetId?: string,
  domainId?: string,
): Promise<TechnicalSheet | undefined> {
  if (technicalSheetId == undefined || domainId == undefined) return;
  const { data } = await axios.get<TechnicalSheet>(
    `/api/materialsmanagement/technicalsheets/${technicalSheetId}/domain/${domainId}`,
  );
  return data;
}

export async function updateTechnicalSheetName(
  technicalSheetId?: string,
  domainId?: string,
  name?: string,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    name == undefined
  )
    return;
  return axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/name/domain/${domainId}`,
      { name },
    )
    .then((response) => response.status)
    .catch((error: unknown) => {
      if (axios.isAxiosError(error)) {
        return error.response?.status;
      }
      return HttpStatusCode.BadRequest;
    });
}

export async function updateTechnicalSheetPrice(
  technicalSheetId?: string,
  domainId?: string,
  priceInclTax?: number,
): Promise<HttpStatusCode | undefined> {
  if (technicalSheetId == undefined || domainId == undefined) return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/priceincltax/domain/${domainId}`,
      { priceInclTax },
    )
    .then((r) => r.status);
}

export async function updateTechnicalSheetVATRate(
  technicalSheetId?: string,
  domainId?: string,
  vatRate?: number,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    vatRate == undefined
  )
    return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/vatrate/domain/${domainId}`,
      { vatRate },
    )
    .then((r) => r.status);
}

export async function updateTechnicalSheetProducedQuantity(
  technicalSheetId?: string,
  domainId?: string,
  producedQuantity?: number,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    producedQuantity == undefined
  )
    return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/producedquantity/domain/${domainId}`,
      { producedQuantity },
    )
    .then((r) => r.status);
}

export async function updateTechnicalSheetFamily(
  technicalSheetId?: string,
  domainId?: string,
  familyId?: string,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    familyId == undefined
  )
    return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/family/${familyId}/domain/${domainId}`,
    )
    .then((r) => r.status);
}

export async function updateTechnicalSheetMajor(
  technicalSheetId?: string,
  domainId?: string,
  majorId?: string,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    majorId == undefined
  )
    return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/major/${majorId}/domain/${domainId}`,
    )
    .then((r) => r.status);
}

export async function updateTechnicalSheetActive(
  technicalSheetId?: string,
  domainId?: string,
  active?: boolean,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    active == undefined
  )
    return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/active/domain/${domainId}`,
      { active: active },
    )
    .then((r) => r.status);
}

export async function updateTechnicalSheetFavorite(
  technicalSheetId?: string,
  domainId?: string,
  favorite?: boolean,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    favorite == undefined
  )
    return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/favorite/domain/${domainId}`,
      { favorite: favorite },
    )
    .then((r) => r.status);
}

export async function updateTechnicalSheetInventoriable(
  technicalSheetId?: string,
  domainId?: string,
  inventoriable?: boolean,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    inventoriable == undefined
  )
    return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/inventoriable/domain/${domainId}`,
      { inventoriable: inventoriable },
    )
    .then((r) => r.status);
}

export async function updateTechnicalSheetTransferable(
  technicalSheetId?: string,
  domainId?: string,
  transferable?: boolean,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    transferable == undefined
  )
    return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/transferable/domain/${domainId}`,
      { transferable: transferable },
    )
    .then((r) => r.status);
}

export async function updateTechnicalSheetComment(
  technicalSheetId?: string,
  domainId?: string,
  comment?: string,
): Promise<HttpStatusCode | undefined> {
  if (
    technicalSheetId == undefined ||
    domainId == undefined ||
    comment == undefined
  )
    return;
  return await axios
    .patch(
      `/api/materialsmanagement/technicalsheets/${technicalSheetId}/comment/domain/${domainId}`,
      { comment },
    )
    .then((r) => r.status);
}
